import { render, staticRenderFns } from "./GenerateBets.vue?vue&type=template&id=af501c2e"
import script from "./GenerateBets.vue?vue&type=script&lang=js"
export * from "./GenerateBets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports